import {
  authHeader,
  handleResponse,
  errorOnActivation,
  handleWithClearErrorResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Limited Release By Serial Number
function getLimitedReleaseBySN(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function createLimitedReleaseBySN(requestBody, queryParams) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function editLimitedReleaseBySN(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function addTargetLimitedReleaseBySN(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/targets`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function removeTargetLimitedReleaseBySN(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release, target } = queryParams;
  const endPoint = `/api/admin/v1/releases/${version}/${release}/targets/${target}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteLimitedReleaseBySN(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function activateLimitedReleaseBySN(queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/activate`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(errorOnActivation)
    .then((data) => {
      return data;
    });
}

function deactivateLimitedReleaseBySN(queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/deactivate`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

export const limitedReleasesSNService = {
  getLimitedReleaseBySN,
  createLimitedReleaseBySN,
  editLimitedReleaseBySN,
  addTargetLimitedReleaseBySN,
  removeTargetLimitedReleaseBySN,
  deleteLimitedReleaseBySN,
  activateLimitedReleaseBySN,
  deactivateLimitedReleaseBySN,
};
